



















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import MultiComponent from '@/components/Controls/MultiComponent.vue';


@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'souffling_list', 'plan_list', 'schemas'
    ]),
    ...mapState('ubic', [
      'token'
    ]),
    ...mapGetters(STORE_KEY, [
    ]),
  },
  components: {
    MultiComponent
  }
})
export default class ShiftVDPFact extends Vue {

  @Prop() documentId!: string;
  @Prop() lineId!: string;

  opened: any[] = [];
  public dropFiles = [];
  public plan_list!: any[];
  public hActiveTab: number | null = null;
  public is_processing = true;
  // переключатель «Очистить наполнение после мойки» по строкам плана (мойки);
  // отсутствующее значение = брать из документа (по умолчанию включено)
  public clearFilling: Record<string, boolean> = {};

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;
    
  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.handleParamsChange(0);
    this.hActiveTab = this.$route.query.plan_tab ? parseInt(this.$route.query.plan_tab as any) : 0
  }

  public handleParamsChange(tab_id: number|null) {
    this.$store.dispatch(`${STORE_KEY}/loadPlans`, {
      documentId: this.documentId,
    }).then(() => {
      this.setTab(tab_id !== null ? tab_id : 0 )
      this.is_processing = false;
    })
  }

  setTab(idx: any) {
    const is_wash = this.plan_list[idx].wash_id
    const line_id = this.plan_list[idx].line_id
    const equipment_id = this.plan_list[idx].equipment_id
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
      lineId: line_id,
      equipmentId: equipment_id,
      types: is_wash ? ['wash']: ['tare', 'bolling']
    });
    this.$router.replace({
      query: {
        ...this.$route.query,
        // @ts-ignore
        plan_tab: idx,
      }
    })  

  }

  public setAccepted(item: any) {
    this.$store.dispatch(`${STORE_KEY}/setAccepted`, {
      documentId: this.documentId,
      item
    }).then(() => {
      this.handleParamsChange(this.hActiveTab)
    });
  }

  public clearFillingValue(plan: any) {
    return this.clearFilling[plan.wash_id] !== undefined
      ? this.clearFilling[plan.wash_id]
      : plan.clear_filling !== false;
  }

  public setClearFilling(plan: any, value: boolean) {
    this.$set(this.clearFilling, plan.wash_id, value);
  }

  public setDone(item: any) {
    this.$store.dispatch(`${STORE_KEY}/setDone`, {
      plan: item,
      clear_filling: this.clearFillingValue(item)
    }).then(() => {
      this.handleParamsChange(this.hActiveTab)
    });
  }

  public setValue(plan_id: any, index: any, value: any) {
    this.$store.dispatch(`${STORE_KEY}/setItemValue`, {
      plan_id, index, newValue: value
    })
  }
}

